<template>
    <thead class="table-head" :class="breakpoint">
        <slot></slot>
    </thead>
</template>
<script>
export default{
    props: {
        breakpoint: {
            type: String,
            default: 'md'
        }
    }
}
</script>

<style lang="scss">
@import '../../../../styles/_custom.scss';
@import "~bootstrap/scss/mixins";

@mixin tableHeadMixin($breakpoint){
     @include media-breakpoint-up($breakpoint){
        display: table-header-group;
    }
}
.ui-data-table{
    .table-head{
        display: none;
        &.md{
            @include tableHeadMixin(md)
        }
        &.lg{
            @include tableHeadMixin(lg)
        }
    }
}

</style>